<template>
  <section> 
    <b-row style="width:500px;margin: auto;">
      <b-col>
        <b-card
          style="max-width: 100%;" >
          <template v-slot:header >
            <div class="header-card text-left">
              Recuperar contraseña 
            </div>      
            <small>Llegara a tu email un mensaje con el link de recuperación</small>      
          </template> 
          <div class="p-3">     
            <b-form-group
                class="mb-0"
                label="Email"
                label-for="input-email"
                description=""
              >
                <b-form-input
                  id="input-email"
                  v-model="user.email"
                  placeholder=""
                ></b-form-input>
            </b-form-group>            
            <div> 
              <b-button @click="solicitarChangePassword(user)" variant="info" style="float:right">Eviar link de recuperación</b-button>
            </div>       
          </div> 
        </b-card>
      </b-col>
    </b-row>                   
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalinactive from '@/components/modals/inactive.vue'
import SwModalusuarios from '@/components/modals/usuarios.vue'


export default { 
  name: "datos_pacientes",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalinactive,
  SwModalusuarios
     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>

